import { Injectable } from '@angular/core';
import { MaskService } from './mask.service';

@Injectable({
    providedIn: 'root',
})
export class DataTransformService {
    constructor(private maskService: MaskService) {}

    /**
     * Transforma dados do formulário antes do submit
     */
    transformFormData(data: any, currencyFields: string[] = ['price', 'pricePerLiter']): any {
        return this.maskService.transformCurrencyFields(data, currencyFields);
    }

    /**
     * Aplica máscaras aos dados carregados do backend
     */
    applyMasksToLoadedData(data: any, config: any[]): any {
        return this.maskService.applyMasksToLoadedData(data, config);
    }

    /**
     * Parse valor de moeda para número (formato brasileiro)
     */
    parseCurrencyValue(value: any): number {
        if (!value) return 0;

        if (typeof value === 'number') return value;

        if (typeof value === 'string') {
            return this.parseBrazilianCurrency(value);
        }

        return 0;
    }

    /**
     * Parse valor de moeda brasileira para float
     * Ex: "R$ 1.002,66" -> 1002.66
     */
    private parseBrazilianCurrency(value: string): number {
        if (!value) return 0;

        // Remove R$, espaços e outros caracteres não numéricos exceto . e ,
        let cleanValue = value.replace(/[R$\s]/g, '');

        // Se não tem vírgula, é um número inteiro
        if (!cleanValue.includes(',')) {
            return parseFloat(cleanValue.replace(/\./g, '')) || 0;
        }

        // Se tem vírgula, é um número decimal
        // Remove pontos (separadores de milhares) e substitui vírgula por ponto
        cleanValue = cleanValue.replace(/\./g, '').replace(',', '.');

        return parseFloat(cleanValue) || 0;
    }
}
